import { FormEvent } from 'react'
import { connect } from 'react-redux'
import CSVToArray from 'tfs.front-end-utils/CSVToArray/CSVToArray'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import constants from '../../config/constants'
import preFillPassengersCSVHeaders from '../../config/preFillPassengersCSVHeaders'

import { addNotification } from '../../actions/notifications'
import { closeCSVUpload } from '../../actions/modals'
import { uploadPassengers } from '../../actions/passengers'

import getLabels from '../../utils/getLabels'
import { buildGenericNotification } from '../../utils/notifications'

import createInputRef from './createInputRef'

import BulkUpload from '../../components/BulkUpload'

const fileInputRef = createInputRef()

interface PreFillNewBookingPassengerPropsInterface {
  pristine: boolean
}

export const mapStateToProps = (
  _state: ReduxStoreInterface,
  props: PreFillNewBookingPassengerPropsInterface
) => ({
  inputRef: fileInputRef,
  isDisabled: !props.pristine,
})

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: async (event: FormEvent<HTMLFormElement>, selectedFlightIds: string) => {
    event.preventDefault()

    if (
      !fileInputRef.current ||
      !fileInputRef.current.files ||
      !fileInputRef.current.files.length
    ) {
      return
    }

    const file = fileInputRef.current.files[0]

    const fileNameParts = file.name.split('.')

    try {
      const _CSVToArray = new CSVToArray({
        includeHeaders: false,
        customHeaders: preFillPassengersCSVHeaders,
      })
      const fileReader = new FileReader()
      fileReader.readAsText(file, constants.csvFileISOType)
      fileReader.onload = () => {
        const fileExtension = fileNameParts[fileNameParts.length - 1]
        if (fileExtension.toLowerCase() !== 'csv') {
          const error = buildGenericNotification(getLabels('csv_invalid'))

          dispatch(addNotification(error))
          return
        }

        const CSVFileContents = _CSVToArray.parse(fileReader.result)

        dispatch(uploadPassengers(CSVFileContents, selectedFlightIds))

        const changeEvent: Event = new Event('change', { bubbles: true })

        const uploadedFields = Array.from(
          document.querySelectorAll<HTMLInputElement | HTMLSelectElement>(
            '[data-uploadedvalue]'
          )
        )

        uploadedFields.forEach(
          (input: HTMLInputElement | HTMLSelectElement) => {
            const valueSet = Object.getOwnPropertyDescriptor(
              window.HTMLInputElement.prototype ||
                window.HTMLSelectElement.prototype,
              'value'
            )!.set

            const value = input.getAttribute('data-uploadedvalue')
            const nodeName = input.nodeName.toLowerCase()

            if (value && value !== '' && nodeName === 'input') {
              valueSet!.call(input, value)
              input.dispatchEvent(changeEvent)
            } else if (value && value !== '' && nodeName === 'select') {
              input.value = value
              input.dispatchEvent(changeEvent)
            }
          }
        )
      }
    } catch (err) {
      const error = buildGenericNotification(getLabels('csv_invalid'))

      dispatch(addNotification(error))
    }
    dispatch(closeCSVUpload())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkUpload)
